<template>
  <div class="container">
    <TomasWidget
      v-if="!isEditing && tomasId"
      :tomas-id="tomasId"
      :max-service-count="maxServiceCount?.toString()"
      :widget-id="configId"
      :type="TomasWidgetType.widget"
      :hide-booking-notice="hideBookingNotice"
    />
    <div v-else-if="isEditing && !tomasId" class="text-red-500 font-bold">
      The given Tomas ID is invalid.
    </div>
    <div v-else>Tomas Placeholder. Close Blökkli to render widget.</div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphTomasFragment } from '#graphql-operations'
import { TomasWidgetType } from '~/layers/tomasBooking/components/TomasWidget/types'

defineProps<ParagraphTomasFragment>()

const { isEditing } = defineBlokkli({
  bundle: 'tomas',
  chunkName: 'rare',
})
</script>
